'use strict';

import AnnouncementsApi from '@api/announcements';

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[app::services::announcements]';

const announcements = async () => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await AnnouncementsApi.announcements();
    return response.data;
}

export default {
    announcements
};